import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { brokenEmbedPreviewTestIds } from './BrokenEmbedPreview.test-ids';

export default function BrokenEmbedPreview() {
  const { t } = useTranslation();

  return (
    <Stack
      data-testid={brokenEmbedPreviewTestIds.root}
      direction="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      width="100%"
      gap={2}
      sx={{ backgroundColor: '#FBFDFE' }}
    >
      <WarningAmberIcon color="warning" sx={{ fontSize: 40 }} />
      <Typography variant="body2" color="text.primary" align="center">
        {t('document.grid.embed.broken_preview_description')}
      </Typography>
    </Stack>
  );
}
